import { useNavigate } from "react-router-dom";
import { AccountShell } from "./AccountShell.js";
import { PerfilContent } from "./PerfilContent.js";

/** Ruta /perfil (técnico) — contenido de perfil dentro del marco de cuenta. */
export function PerfilPage() {
  const navigate = useNavigate();
  return (
    <AccountShell active="perfil">
      <PerfilContent onVerManual={() => navigate("/manual")} />
    </AccountShell>
  );
}
